// TEAMS Website - ActivitiesSection Component
// Featured projects showcase

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useScrollReveal, useScrollRevealStagger } from '../../hooks/useScrollReveal.js';
import { getFeaturedProjects } from '../../data/projects.js';
import i18n from 'i18next';
import { convertAssetPath } from '../../utils/assetPath.js';
import { ANIMATION_TIMING } from '../../styles/animation.js';
import ProjectCard from '../ui/ProjectCard.jsx';
import Button from '../ui/Button.jsx';
import '../../styles/main.scss';
import SectionHeader from '../ui/SectionHeader.jsx';

const ActivitiesSection = () => {
  const { t } = useTranslation();
  const [ref, isVisible] = useScrollReveal({ threshold: 0.1 });

  // Get featured projects
  const featuredProjects = getFeaturedProjects();
  const currentLang = i18n.language;
  const [containerRef, cardElements] = useScrollRevealStagger(featuredProjects.length, { staggerDelay: ANIMATION_TIMING.STAGGER_DELAY });

  return (
    <section className="activities-section" ref={ref}>
      <div className="activities-section__container">
        <div className={`activities-section__content ${isVisible ? 'activities-section__content--visible' : ''}`}>
          {/* Section Header */}
          <SectionHeader
            title={t('activities.title')}
            subtitle=""   //{t('activities.subtitle')}
            alignment="center"
            size="large"
          />

          {/* Projects Grid */}
          <div 
            ref={containerRef}
            className="activities-section__projects"
          >
            {featuredProjects.map((project, index) => (
                <ProjectCard
                  key={index}
                  ref={cardElements[index]?.ref}
                  className={`activities-section__project-card ${
                    cardElements[index]?.isVisible ? 'activities-section__project-card--visible' : ''
                  }`}
                  image={project.image}
                  title={project.title[currentLang]}
                  subtitle={project.subtitle[currentLang]}
                  tags={project.tags}
                  fontFamily={project.fontFamily}
                  link={convertAssetPath(`/projects/${project.slug}`)}
                  style={{
                    '--project-accent': project.accentColor,
                    '--project-accent-light': project.accentColor + '20',
                    '--project-accent-dark': project.accentColor + 'cc'
                  }}
                />
            ))}
          </div>

          {/* Additional CTA for mobile */}
          <div className="activities-section__mobile-cta">
            <Link to="/projects">
              <Button variant="primary" size="large" className="activities-section__mobile-button">
                {t('activities.viewAll')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActivitiesSection;
